import { Fragment } from 'react'
import { Button } from '../../design'
import { formatDateTime } from '../../lib/time'
import { AI_CREDENTIALS_COPY } from './aiCredentialsCopy'

export type CredentialRow = { label: string; value: string }

export interface AiCredentialsDetailsProps {
  rows: readonly CredentialRow[]
  secretLabel: string
  secretUpdatedAt: string
  verifiedAt: string
  onEdit: () => void
  onRemove: () => void
}

export const AiCredentialsDetails = ({
  rows,
  secretLabel,
  secretUpdatedAt,
  verifiedAt,
  onEdit,
  onRemove,
}: AiCredentialsDetailsProps) => (
  <div className="ai-credentials-details">
    <dl className="settings-readonly">
      {rows.map((row) => (
        <Fragment key={row.label}>
          <dt>{row.label}</dt>
          <dd className="num">{row.value}</dd>
        </Fragment>
      ))}
      <dt>{secretLabel}</dt>
      <dd className="text-tone tone-success">{AI_CREDENTIALS_COPY.secretStored}</dd>
      <dt>{AI_CREDENTIALS_COPY.secretUpdatedAt}</dt>
      <dd className="num">{formatDateTime(new Date(secretUpdatedAt))}</dd>
      <dt>{AI_CREDENTIALS_COPY.verifiedAt}</dt>
      <dd className="num">{formatDateTime(new Date(verifiedAt))}</dd>
    </dl>
    <div className="ai-credentials-actions">
      <Button onClick={onEdit}>{AI_CREDENTIALS_COPY.edit}</Button>
      <Button variant="danger" onClick={onRemove}>
        {AI_CREDENTIALS_COPY.remove}
      </Button>
    </div>
  </div>
)
